import { HISTORY_IMAGES } from "@/lib/utils";

const HistoryImageGrid = () => {
  return (
    <div className="relative w-full max-w-[800px] mx-auto">
      {HISTORY_IMAGES.map((img, index) => (
        <img
          key={index}
          src={img.src}
          alt={img.alt}
          className={img.className}
          style={img.style}
        />
      ))}
    </div>
  );
};

export default HistoryImageGrid;
